// Sprint 4 — Billing API schemas.
//
// Shared between backend (route validation) and mobile (typed API client)
// so the wire contract has a single source of truth.
import { z } from 'zod';
/** Plans the user can subscribe to via Stripe Checkout. Excludes FREE
 *  (implicit) and the role-derived plans (VET, BUYER, INDUSTRY) which
 *  bill through other channels in later sprints. */
export const BillablePlanSchema = z.enum(['FARMER_BASIC', 'FARMER_PRO']);
export const SubscriptionResponseSchema = z.object({
    plan: z.enum(['FREE', 'FARMER_BASIC', 'FARMER_PRO', 'VET', 'BUYER', 'INDUSTRY']),
    has_subscription: z.boolean(),
    renews_at: z.string().datetime().nullable(),
    trial_days: z.number().int().nonnegative(),
});
export const CheckoutSessionRequestSchema = z.object({
    plan: BillablePlanSchema,
});
export const StripeRedirectResponseSchema = z.object({
    url: z.string().url(),
});
//# sourceMappingURL=billing.js.map